"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.upload = void 0;
exports.upload = {
    path: "M4.16669 17.6667H15.8334V16H4.16669V17.6667ZM4.16669 8.83334H7.50002V13.8333H12.5V8.83334H15.8334L10 3.00001L4.16669 8.83334ZM10.8334 7.16669V12.1667H9.16669V7.16669H8.19169L10 5.35835L11.8084 7.16669H10.8334Z",
    originalWidth: 20,
    originalHeight: 20,
    basicColor: "tableGray1",
    activeColor: "tableBlack2",
};
